export default () => {

  const $mainSliderWrapper = $('.main-slider-wrapper');

  if ($mainSliderWrapper.length === 0) {
    return;
  }

  const $mainSlider = $mainSliderWrapper.find('.main-slider');
  const $mainSliderControls = $mainSliderWrapper.find('.main-slider__controls');

  if ($mainSlider.find('.main-slider__item').length <= 1) {
    $mainSliderControls.addClass('is-disable');
  }

  const updateSliderCounter = (slick, currentIndex) => {
    const currentSlide = currentIndex || slick.slickCurrentSlide() + 1;
    const slidesCount = slick.slideCount;
    $mainSliderControls.find('.main-slider__current').text(`0${currentSlide}`);
    $mainSliderControls.find('.main-slider__max').text(`0${slidesCount}`);
  };

  $mainSlider.on('init', (e, slick) => {
    updateSliderCounter(slick);
  });

  $mainSlider.on('beforeChange', (e, slick, currentSlide, nextSlide) => {
    updateSliderCounter(slick, nextSlide + 1);
  });

  $mainSlider.slick({
    fade: true,
    dots: true,
    arrows: false,
    appendDots: '.main-slider__dots',
    autoplay: true,
    autoplaySpeed: 5000,
  });

};
